export const ServiceUrl = {
  V2_LOGIN: {
    CHECK_USERNAME: "v2/login/check-username",
    CAPTCHA: "v1/captcha",
    VERIFY_CAPTCHA: "v2/login/verify-captcha",
    UPDATE_PASSWORD: "v2/login/update-pass",
  },

  LOGIN_V2: {
    CHECK: "/v2/admin/check",
    CHECK_USERNAME: "/v1/admin/login",
  },
  COURSES: {
    CATEGORY_CREATE: "v1/admin/course/category/create",
    CATEGORY_LIST: "v1/admin/course/category/list",
    CATEGORY_DELETE: "v1/admin/course/category/delete",
    CATEGORY_UPDATE: "v1/admin/course/category/update",
    CATEGORY_SLUG_UPDATE: "v1/admin/course/category/update-slug",

    LEVEL_CREATE: "v1/admin/course/level/create",
    LEVEL_LIST: "v1/admin/course/level/list",
    LEVEL_DELETE: "v1/admin/course/level/delete",
    LEVEL_UPDATE: "v1/admin/course/level/update",

    DEGREE_CREATE: "v1/admin/course/degree/create",
    DEGREE_LIST: "v1/admin/course/degree/list",
    DEGREE_DELETE: "v1/admin/course/degree/delete",
    DEGREE_UPDATE: "v1/admin/course/degree/update",
    ADD_SPECIALIZATION: "v1/admin/course/degree/add-specialization",
    SPECIALIZATION_LIST: "v1/admin/course/degree/list-specialization",
    SPECIALIZATION_UPDATE: "v1/admin/course/degree/update-specialization",
    SPECIALIZATION_DELECT: "v1/admin/course/degree/delect-specialization",

    COURSE_CREATE: "v1/admin/course/create",
    ADD_COURSE_CODE: "v1/admin/course/add-course-code",
    COURSE_CODE_LIST: "v1/admin/course/list-course-code",
    COURSE_CODE_DELETE: "v1/admin/course/delect-course-code",
    COURSE_CODE_UPDATE: "v1/admin/course/update-course-code",
    LIST_CATEGORY_BY_DEGREE_BY_COURSE: "v1/admin/course/list-degree-course",
    LIST_CATEGORY_BY_DEGREE_BY_COURSE_BY_COLLEGE:
      "v1/admin/course/list-degree-course-in-college",
    COURSE_LIST: "v1/admin/course/list",
    COURSE_SPL_LIST: "v1/admin/course/specialization-list",
    CHECK_COURSE_LIST: "v1/admin/course/course-list",
    COURSE_LIST_MININFO: "v1/admin/course/min-info",
    COURSE_DELETE: "v1/admin/course/delete",
    COURSE_UPDATE_BASIC: "v1/admin/course/update-basic",
    COURSE_UPDATE_CONTENT: "v1/admin/course/update-content",
    COURSE_UPDATE_SLUG: "v1/admin/course/update-slug",
  },
  COLLEGES: {
    COUNTRY_CREATE: "v1/admin/country/create",
    COUNTRY_LIST: "v1/admin/country/list",
    COUNTRY_DELETE: "v1/admin/country/delete",
    COUNTRY_UPDATE: "v1/admin/country/update",

    STATE_CREATE: "v1/admin/state/create",
    STATE_LIST: "v1/admin/state/list",
    STATE_CODE_LIST: "v1/admin/state/list-state-code",
    STATE_DELETE: "v1/admin/state/delete",
    STATE_UPDATE: "v1/admin/state/update",

    DISTRICT_CREATE: "v1/admin/district/create",
    DISTRICT_LIST: "v1/admin/district/list",
    DISTRICT_DELETE: "v1/admin/district/delete",
    DISTRICT_UPDATE: "v1/admin/district/update",

    CITY_CREATE: "v1/admin/city/create",
    CITY_LIST: "v1/admin/city/list",
    CITY_DELETE: "v1/admin/city/delete",
    CITY_UPDATE: "v1/admin/city/update",

    FILTER_CREATE: "v1/admin/filter/create",
    FILTER_CATEGORIES: "v1/admin/filter/list",
    FILTER_DELETE: "v1/admin/filter/delete",
    FILTER_UPDATE: "v1/admin/filter/update",
    FILTER_LIST_CAT: "v1/admin/filter/list-categories",

    FILTER_CREATE_OPTIONS: "v1/admin/filter/create-option",
    FILTER_CATEGORIES_OPTIONS: "v1/admin/filter/option-list",
    FILTER_DELETE_OPTIONS: "v1/admin/filter/option-delete",
    FILTER_UPDATE_OPTIONS: "v1/admin/filter/option-update",

    TYPE_CREATE: "v1/admin/college/type/create",
    TYPE_LIST: "v1/admin/college/type/list",
    TYPE_DELETE: "v1/admin/college/type/delete",
    TYPE_UPDATE: "v1/admin/college/type/update",

    COLLEGE_CREATE: "v1/admin/college/create",
    COLLEGE_LIST: "v1/admin/college/list",
    COLLEGE_LIST_ALL: "v1/admin/college/list-all",
    AFFILIATED_LIST: "v1/admin/college/affiliated-list",
    COLLEGE_CHECK_LIST: "v1/admin/college/list-college",
    COLLEGE_DELETE: "v1/admin/college/delete",
    COLLEGE_UPDATE_BASIC: "v1/admin/college/update-basic",
    COLLEGE_UPDATE_CONTENT: "v1/admin/college/update-content",

    CLG_ADD_FACULTY_TAB: "v1/admin/faculty/add-faculty-content",
    CLG_EDIT_FACULTY_TAB: "v1/admin/faculty/update-faculty-content",
    CLG_DELETE_FACULTY_TAB: "v1/admin/faculty/delete-faculty-content",
    CLG_LIST_FACULTY_TAB: "v1/admin/faculty/list-faculty-content",

    CLG_ADD_HOSTEL_TAB: "v1/admin/faculty/add-hostel-content",
    CLG_EDIT_HOSTEL_TAB: "v1/admin/faculty/update-hostel-content",
    CLG_DELETE_HOSTEL_TAB: "v1/admin/faculty/delete-hostel-content",
    CLG_LIST_HOSTEL_TAB: "v1/admin/faculty/list-hostel-content",

    CLG_ADD_FACILITIES_TAB: "v1/admin/faciliticies/add-college-facilites",
    CLG_LIST_FACILITIES_TAB: "v1/admin/faciliticies/list-college-facilites",
    CLG_EDIT_FACILITIES_TAB: "v1/admin/faciliticies/update-college-facilites",
    CLG_DELETE_FACILITIES_TAB: "v1/admin/faciliticies/delect-college-facilites",

    CLG_ADD_PLACEMENT_TAB: "v1/admin/placement/add-college-placement",
    CLG_LIST_PLACEMENT_TAB: "v1/admin/placement/list-college-placement",
    CLG_EDIT_PLACEMENT_TAB: "v1/admin/placement/update-college-placement",
    CLG_DELETE_PLACEMENT_TAB: "v1/admin/placement/delect-college-placement",

    COLLEGE_ADD_COURSE: "v1/admin/college/add-course",
    COLLEGE_LIST_COURSES: "v1/admin/college/list-courses",
    COLLEGE_DELETE_COURSE: "v1/admin/college/delete-course",
    COLLEGE_HIDE_COURSE: "v1/admin/college/hide-course",
    COLLEGE_UPDATE_COURSE: "v1/admin/college/update-course",
    COLLEGE_UPDATE_CATEGORIES: "v1/admin/college/update-categories",
    COLLEGE_UPDATE_IMAGE: "v1/admin/college/update-image",
    COLLEGE_UPDATE_SLUG: "v1/admin/college/update-slug",

    GROUPING_COLLEGE: "v1/admin/college/save-group-college",
    LIST_GROUP_COLLEGE: "v1/admin/college/list-group-college",
    UPDATE_GROUP_COLLEGE: "v1/admin/college/update-group-college",
    DELECT_GROUP_COLLEGE: "v1/admin/college/delect-group-college",

    COLLEGE_ADD_EXAM: "v1/admin/college/add-exams",
    COLLEGE_LIST_EXAMS: "v1/admin/college/list-college-exams",
    COLLEGE_UPDATE_EXAM: "v1/admin/college/update-college-exams",
    COLLEGE_DELECT_EXAM: "v1/admin/college/delect-college-exams",
    COLLEGE_LIST_NOTIFICATIONS: "v1/admin/college/list-notifications",
    COLLEGE_CREATE_NOTIFICATION: "v1/admin/college/save-notification",
    COLLEGE_DELETE_NOTIFICATION: "v1/admin/college/delete-notification",
    COLLEGE_UPDATE_NOTIFICATION: "v1/admin/college/update-notification",

    COLLEGE_CREATE_NEWS: "v1/admin/college/save-news",
    COLLEGE_LIST_NEWS: "v1/admin/college/list-news",
    COLLEGE_UPDATE_NEWS: "v1/admin/college/update-news",
    COLLEGE_DELECT_NEWS: "v1/admin/college/delete-news",

    COLLEGE_ADD_FAQS: "v1/admin/faqs/save-faqs",
    COLLEGE_LIST_FAQS: "v1/admin/faqs/list-faqs",
    COLLEGE_UPDATE_FAQs: "v1/admin/faqs/update-faqs",
    COLLEGE_DELECT_FAQs: "v1/admin/faqs/delete-faqs",

    COLLEGE_CREATE_CUTTOFF: "v1/admin/college/save-cuttoff",
    COLLEGE_LIST_CUTTOFF: "v1/admin/college/list-cutoff",
    COLLEGE_DELECT_CUTOFF: "v1/admin/college/delete-cutoff",
    COLLEGE_UPDATE_CUTOFF: "v1/admin/college/update-cuttoff",
    COLLEGE_LIST_CUTTOFF_EDIT: "v1/admin/college/list-cutoffedit",

    COLLEGE_CREATE_VIDEOLINK: "v1/admin/college/video-link",
    COLLEGE_DELETE_VIDEOLINK: "v1/admin/college/delete-video-link",
    COLLEGE_CREATE_VIDEOLINKS: "v1/admin/college/video-links",

    COLLEGE_UPLOAD_IMAGES: "v1/admin/college/upload-images",
    COLLEGE_UPLOADED_IMAGES: "v1/admin/college/images",
    COLLEGE_DELETE_IMAGE: "v1/admin/college/delete-image",
    LIST_CATEGORY_BY_COURSE: "v1/admin/college/categorybycourse",

    COLLEGES_REVIEW_LIST: "v1/admin/college/list-review",
    COLLEGES_REVIEW_UPDATE: "v1/admin/college/update-review",
    RANKING: "v1/admin/college/save-ranking",
    LIST_RANKING: "v1/admin/college/list-ranking",
    UPDATE_RANKING: "v1/admin/college/update-ranking",
    DELECT_RANKING: "v1/admin/college/delect-ranking",

    ADD_RANKING_STRAME: "v1/admin/college/add-ranking-strame",
    LIST_RANKING_STRAME: "v1/admin/college/list-ranking-strame",
    UPDATE_RANKING_STRAME: "v1/admin/college/update-ranking-strame",
    DELECT_RANKING_STRAME: "v1/admin/college/delect-ranking-strame",

    LIST_COLLEGE_PREDICTOR: "v1/admin/college-predictor/list-college-predictor",
    LIST_PREDICTOR_EXAMS: "v1/admin/college-predictor/list-predictor-exams",
    SAVE_COLLEGE_PREDICTOR: "v1/admin/college-predictor/save-college-predictor",
    SAVE_COLLEGE_PREDICTOR_BULK:
      "v1/admin/college-predictor/save-college-predictor-bulk",
    UPDATE_COLLEGE_PREDICTOR:
      "v1/admin/college-predictor/update-college-predictor",
    DELECT_COLLEGE_PREDICTOR:
      "v1/admin/college-predictor/delete-college-predictor",

    ADD_COLLEGE_RANKING: "v1/admin/college/add-college-ranking",
    LIST_COLLEGE_RANKING: "v1/admin/college/list-college-ranking",
    UPDATE_COLLEGE_RANKING: "v1/admin/college/update-college-ranking",
    DELECT_COLLEGE_RANKING: "v1/admin/college/delect-college-ranking",
    LIST_COLLEGE_RANKING_GROUPBY:
      "v1/admin/college/list-college-ranking-groupby",

    ADD_BANNAR: "v1/admin/college/add-bannar",
    LIST_BANNAR: "v1/admin/college/list-bannar",
    UPDATE_BANNAR: "v1/admin/college/update-bannar",
    LIST_BY_COLLEGES: "v1/admin/college/list-by-colleges",
    DELECT_BANNAR: "v1/admin/college/delect-bannar",

    LIST_COLLEGE_REVIEW: "v1/admin/college/list-college-review",
    LIST_COLLEGE_NAME: "v1/admin/college/list-college-name",

    SAVE_PREDITOR: "v1/admin/college/save-preditor",
    LIST_PREDITOR: "v1/admin/college/list-preditor",
    COLLEGE_LIST_PREDICTOR_EDIT: "v1/admin/college/list-preditoredit",
    COLLEGE_UPDATE_PREDICTOR: "v1/admin/college/update-preditor",
    COLLEGE_DELETE_PREDICTOR: "v1/admin/college/delete-preditor",
    COLLEGE_DELETE_PREDICTOR_ATTI: "v1/admin/college/delete-preditor-atti",
    ADD_APPROVE_CERTIFICATEC: "v1/admin/college/add-approvel-colleges",
    LIST_APPROVE_CERTIFICATEC: "v1/admin/college/list-approvel-colleges",
    UPDATE_APPROVE_CERTIFICATEC: "v1/admin/college/update-approvel-colleges",
    DELECT_APPROVE_CERTIFICATEC: "v1/admin/college/delect-approvel-colleges",

    APPLICATION_COURSE_ADD: "v1/admin/applicationcolleges/add",
    APPLICATION_COURSE_RECOVERY:
      "v1/admin/applicationcolleges/application-course-recovery",
    APPLICATION_COURSE_ADD_BULK: "v1/admin/applicationcolleges/add-bulk",
    APPLICATION_COURSE_UPDATE_ORDER:
      "v1/admin/applicationcolleges/update-order",
    APPLICATION_COURSE_LIST: "v1/admin/applicationcolleges/list",
    APPLICATION_COURSE_DELECT: "v1/admin/applicationcolleges/delect",

    //ADD_COLLEGE_APPROVEL_CERTIFICATE: "v1/admin/cerificate/add",
  },
  MENUS: {
    ADD_COLLEGE_MENU: "v1/admin/menu/add-college-menu",
    LIST_COLLEGE_MENU: "v1/admin/menu/list-college-menus",
    UPDATE_COLLEGE_MENUS: "v1/admin/menu/update-college-menus",
    DELECT_COLLEGE_MENUS: "v1/admin/menu/delect-college-menus",

    ADD_SUB_MENU: "v1/admin/menu/add-sub-menus",
    LIST_SUB_MENU: "v1/admin/menu/list-sub-menus",
    UPDATE_SUB_MENU: "v1/admin/menu/update-sub-menus",
    DELECT_SUB_MENU: "v1/admin/menu/delect-sub-menus",
  },

  CARRER: {
    ADD_CAREER_HEADING: "v1/admin/career/add-heading",
    LIST_CAREER: "v1/admin/career/list-heading",
    UPDATE_CAREER_HEADING: "v1/admin/career/update-headings",

    ADD_CAREER_TITLE: "v1/admin/career/add-title",
    LIST_CAREER_TITLE: "v1/admin/career/list-title",
    UPDATE_CAREER_TITLE: "v1/admin/career/update-title",
    DELECT_CAREER_TITLE: "v1/admin/career/delect-title",
  },
  NEWS: {
    ADD_NEWS_TYPE: "v1/admin/news/type-add",
    LIST_NEWS_TYPE: "v1/admin/news/type-list",
    UPDATE_NEWS_TYPE: "v1/admin/news/type-update",
    DELECT_NEWS_TYPE: "v1/admin/news/type-delect",

    ADD_NEWS: "v1/admin/news/news-add",
    LIST_NEWS: "v1/admin/news/news-list",
    UPDATE_NEWS: "v1/admin/news/news-update",
    DELECT_NEWS: "v1/admin/news/news-delect",

    ADD_NEWS_CONTENT: "v1/admin/news/news-add-content",
    LIST_NEWS_CONTENT: "v1/admin/news/news-list-content",
    UPDATE_NEWS_CONTENT: "v1/admin/news/news-update-content",
    DELECT_NEWS_CONTENT: "v1/admin/news/news-delect-content",
    UPDATE_CONTENT: "v1/admin/news/news-update-content-data",
  },
  ADMISSION: {
    SETTINGS_MENU: "v1/admin/settings/menu-list",
    SETTINGS: "v1/settings",
    LIST_VARIABLE_SETTINGS: "v1/admin/settings/list-settings",
    UPDATE_VARIABLE_SETTINGS: "v1/admin/settings/update-settings",
    ADD_VARIABLE_SETTINGS: "v1/admin/settings/add-settings",

    LIST_SMS_TEMPLATES: "v1/admin/smstemplate/list-templates",
    UPDATE_SMS_TEMPLATES: "v1/admin/smstemplate/update-template",
    ADD_SMS_TEMPLATES: "v1/admin/smstemplate/add-template",
    DELETE_SMS_TEMPLATES: "v1/admin/smstemplate/delete-template",

    LIST_WEBSITE_TEMPLATES: "v1/admin/webtemplate/list-templates",
    UPDATE_WEBSITE_TEMPLATES: "v1/admin/webtemplate/update-template",
    ADD_WEBSITE_TEMPLATES: "v1/admin/webtemplate/add-template",
    DELETE_WEBSITE_TEMPLATES: "v1/admin/webtemplate/delete-template",
    LIST_WEBSITE_TEMP_DESIGN: "v1/admin/webtemplate/list-temp-design",
    UPDATE_WEBSITE_TEMPLATE_DESIGN: "v1/admin/webtemplate/update-temp-design",

    LIST_MAIL_TEMPLATES: "v1/admin/mailtemplate/list-templates",
    UPDATE_MAIL_TEMPLATES: "v1/admin/mailtemplate/update-template",
    ADD_MAIL_TEMPLATES: "v1/admin/mailtemplate/add-template",
    DELETE_MAIL_TEMPLATES: "v1/admin/mailtemplate/delete-template",

    USER_PROFILE: "v1/admin/users/my-profile",
    USER_CHANGE_PASSWORD: "v1/admin/users/change-password",

    NEW_USER_LOGIN: "v1/admin/users/save-user",
    LIST_USERS_LOGIN: "v1/admin/users/list-users",
    USER_STATUS_CHANGE: "v1/admin/users/status-change",
    REMOVE_USER_LOGIN: "v1/admin/users/remove-user",
    UPDATE_USER_LOGIN: "v1/admin/users/update-user",
    PASS_USER_LOGIN: "v1/admin/users/user-password",
  },

  SETTINGS: {
    SAVE_USERROLE: "v1/admin/rbac/userrole/save",
    LIST_USERROLE: "v1/admin/rbac/userrole/list",
    DELETE_USERROLE: "v1/admin/rbac/userrole/delete",
    UPDATE_USERROLE: "v1/admin/rbac/userrole/update",

    SAVE_ROLE_MODULE: "v1/admin/rbac/roleaccess/save-module",
    DELETE_ROLE_MODULE: "v1/admin/rbac/roleaccess/delete-module",
    UPDATE_ROLE_MODULE: "v1/admin/rbac/roleaccess/update-module-access",
    UPDATE_USER_ACCESS: "v1/admin/rbac/roleaccess/update-user-access",
    LIST_ROLE_ACCESS: "v1/admin/rbac/roleaccess/access-list",
    UPDATE_ROLE_ACCESS: "v1/admin/rbac/roleaccess/update-role-access",
    LIST_ROLE_PERMISSIONS: "v1/admin/rbac/roleaccess/list-role-permissions",

    LIST_COMMUNITY: "v1/set/community",
    LIST_RELIGIONS: "v1/set/religions",
    LIST_USER_LOGS: "v1/admin/logs/list-all",
    LIST_USER_LOGS_BY_ID: "v1/admin/logs/list-user-log",

    SAVE_FACILITIES: "v1/admin/faciliticies/save",
    LIST_FACILITIES: "v1/admin/faciliticies/list",
    UPDATE_FACILITIES: "v1/admin/faciliticies/update",
    DELECT_FACILITIES: "v1/admin/faciliticies/delect",

    SAVE_PLACEMENT: "v1/admin/placement/save",
    LIST_PLACEMENT: "v1/admin/placement/list",
    UPDATE_PLACEMENT: "v1/admin/placement/update",
    DELECT_PLACEMENT: "v1/admin/placement/delect",

    SAVE_COMMUNITY: "v1/admin/community/save",
    LIST_COMMUNITY_ALL: "v1/admin/community/list",
    LIST_EXAMS_WISE_COMMUNITY: "v1/admin/community/exms-comunity-list",
    UPDATE_COMMUNITY: "v1/admin/community/update",
    DELECT_COMMUNITY: "v1/admin/community/delect",

    SAVE_QUOTA: "v1/admin/quota/save",
    LIST_QUOTA: "v1/admin/quota/list",
    UPDATE_QUOTA: "v1/admin/quota/update",
    DELECT_QUOTA: "v1/admin/quota/delect",

    SAVE_COLLABORATE: "v1/admin/collaborate/save",
    LIST_COLLABORATE: "v1/admin/collaborate/list",
    UPDATE_COLLABORATE: "v1/admin/collaborate/update",
    DELECT_COLLABORATE: "v1/admin/collaborate/delect",

    AFFILIATED_LIST: "v1/admin/affiliated/list",
    AFFILIATED_ADD: "v1/admin/affiliated/add",
    AFFILIATED_UPDATE: "v1/admin/affiliated/update",
    AFFILIATED_DELECT: "v1/admin/affiliated/delect",
  },
  WEBSITE_CMS: {
    SAVE_PAGE: "v1/admin/cms/page/save",
    LIST_PAGES: "v1/admin/cms/page/list",
    DELETE_PAGE: "v1/admin/cms/page/delete",
    GET_PAGE: "v1/admin/cms/page/get",
    UPDATE_PAGE: "v1/admin/cms/page/update",
    GET_EVENT_CATEGORY: "v1/admin/cms/page/get-event-category",

    SAVE_GALLERY: "v1/admin/cms/page/save-gallery",
    LIST_GALLERIES: "v1/admin/cms/page/list-galleries",
    DELETE_GALLERY: "v1/admin/cms/page/delete-gallery",
    LIST_GALLERY: "v1/admin/cms/page/list-gallery",
    UPDATE_GALLERY: "v1/admin/cms/page/update-gallery",

    LIST_CATEGORY_NAMES: "v1/admin/cms/page/list-categories",

    FILES_LIST_DIRECTORY: "v1/admin/files/list-directory-v2 ",
    FILES_UPLOAD: "v1/admin/files/upload-files-v2",
    REMOVE_FILE: "v1/admin/files/remove-v2",
    CREATE_FOLDER: "v1/admin/files/create-folder-v2",
  },

  ENQUIRY: {
    LIST_ENQUIRY: "v1/admin/enquiry/list",
    LIST_OVERALL_ENQUIRY: "v1/admin/enquiry/overall-list",
    UPDATE_ENQUIRY: "v1/admin/enquiry/update",
    ADD_ADVERTISEMENT: "v1/admin/enquiry/add-advertisment",
    DELECT_ADVERTISEMENT: "v1/admin/enquiry/delect-advertisment",
    EDIT_ADVERTISEMENT: "v1/admin/enquiry/edit-advertisment",
    LIST_ADVERTISEMENT: "v1/admin/enquiry/list-advertisment",
    LIST_APPLICATION_FORM: "v1/admin/enquiry/application-form-list",
    LIST_COLLEGE_APPLICATION_FORM:
      "v1/admin/enquiry/college-application-form-list",
    LIST_COLLEGE_APPLICATION_FORM_ID:
      "v1/admin/enquiry/college-application-form-list-id",
    DELECT_SITE_ENQUIRY: "v1/admin/enquiry/delect-site-enquiry",
    DELECT_COURES_ENQUIRY: "v1/admin/enquiry/delect-enquiry",
    LIST_COURSEENQUIRY: "v1/admin/course/enquiry/list",
    LIST_ENQUIRY_COLLEGE_LIST: "v1/admin/course/enquiry/list-enqueriy-colleges",
    SAVE_CONTACT: "v1/admin/course/enquiry/save-contact",
    LIST_CONTACTS: "v1/admin/course/enquiry/list-contacts",
    DELECT_CONTACTS: "v1/admin/course/enquiry/delect-contacts",
    TRENDING_SERACH: "v1/admin/course/enquiry/create-trending-search",
    LIST_TRENDING_SEARCH: "v1/admin/course/enquiry/list-trending-search",
    DELECT_TRENDING_SEARCH: "v1/admin/course/enquiry/delect-trending-search",
    UPDATE_TRENDING: "v1/admin/course/enquiry/update-trending",
    COLLEGE_COURES_ENQUIRY_LIST: "v1/admin/college-course/enquiry/list",
  },
  DASHBOARD: {
    LIST_VISTER_COUNTER: "v1/admin/dashboard/list-vister-counter",
    ADD_LINK_WHATSAPP: "v1/admin/dashboard/add-link-whatsapp",
    LIST_LINK_WHATSAPP: "v1/admin/dashboard/list-link-whatsapp",
    UPDATE_LINK_WHATSAPP: "v1/admin/dashboard/update-link-whatsapp",
    DELECT_LINK_WHATSAPP: "v1/admin/dashboard/delect-link-whatsapp",
    TODAY_LOGIN_STAFF: "v1/admin/dashboard/login-staff-today",

    TODAY_ENQUIRY: "v1/admin/dashboard/today-enquiry",
  },

  FIELD_SETTINGS: {
    NEW: "v1/field_settings/new",
    LIST: "v1/field_settings/all",
    REMOVE: "v1/field_settings/delete",
    UPDATE: "v1/field_settings/update",
  },
  SMS: {
    CHECK_BALANCE: "v1/admin/sms/balance",
  },
  REVIEWS: {
    LIST_COLLEGES_REVIEWS: "v1/admin/review/list",
    APPORVE_COLLEGES_REVIEWS: "v1/admin/review/apporve-review",
    DELECT_COLLEGES_REVIEWS: "v1/admin/review/delect-review",
  },
  ADVERTISEMENT: {
    ADD_COLLEGES_ADVERTISEMENT: "v1/admin/advertisements/add",
    LIST_COLLEGES_ADVERTISEMENT: "v1/admin/advertisements/list",
    LIST_COLLEGES_ADVERTISEMENT_BY_ID: "v1/admin/advertisements/list-by-id",
    UPDATE_COLLEGES_ADVERTISEMENT: "v1/admin/advertisements/update",
    DELECT_COLLEGES_ADVERTISEMENT: "v1/admin/advertisements/delect",
    DELECT_SINGLE_ADVERTISEMENT: "v1/admin/advertisements/delect-single-add",
  },

  EXAMS: {
    EXAMS_CREATE: "v1/admin/exams/create",
    EXAMS_MENU_ADD: "v1/admin/exams/add-menu",
    FEATURED_EXAMS_ADD: "v1/admin/exams/add-featured-exam",
    LIST_MENU: "v1/admin/exams/list-menu",
    LIST_FEATURED_EXAM: "v1/admin/exams/list-featured-exam",
    UPDATE_MENU: "v1/admin/exams/update-menu",
    UPDATE_FEATURE_EXAM: "v1/admin/exams/update-feature-exam",
    DELETE_MENU: "v1/admin/exams/delect-menu",
    DELETE_FEATURE_EXAM: "v1/admin/exams/delect-feature-exam",
    ADD_SUB_MENU: "v1/admin/exams/add-submenu",
    LIST_SUB_MENU: "v1/admin/exams/list-sub-menu",
    EXAMS_UPDATE_BASIC: "v1/admin/exams/update-basic",
    EXAMS_LIST: "v1/admin/exams/exam-list",
    ALL_EXAMS_LIST: "v1/admin/exams/exam-list-all",
    EXAMS_UPDATE_CONTENT: "v1/admin/exams/update-list",
    EXAMS_DELETE: "v1/admin/exams/delect-exam",
    EXAM_UPDATE_IMAGE: "v1/admin/exams/update-exam-image",
    EXAM_NOTIFICATION: "v1/admin/exams/add-notification",
    LIST_EXAM_NOTIFICATION: "v1/admin/exams/list-notification",
    UPDATE_EXAM_NOTIFICATION: "v1/admin/exams/update-notification",
    DELECT_EXAM_NOTIFICATION: "v1/admin/exams/delect-notification",
    EXAM_DETALILS_ADD: "v1/admin/exams/exam-details-add",
    EXAM_DETAILS_LIST: "v1/admin/exams/exam-details-list",
    EXAM_DETAILS_UPDATE: "v1/admin/exams/exam-details-update",
    EXAM_DETAILS_DELECT: "v1/admin/exams/exam-details-delect",

    ADD_EXAMS_MENU: "v1/admin/exams/add-exams-menu",
    LIST_EXAMS_MENU: "v1/admin/exams/list-exams-menu",
    UPDATE_EXAMS_MENU: "v1/admin/exams/update-exams-menu",
    DELECT_EXAMS_MENU: "v1/admin/exams/delect-exams-menu",

    ADD_EXAMS_RANGE: "v1/admin/exams/add-ranges",
    LIST_EXAMS_RANGE: "v1/admin/exams/list-ranges",
    UPDATE_EXAMS_RANGE: "v1/admin/exams/update-ranges",
    DELECT_EXAMS_RANGE: "v1/admin/exams/delect-ranges",
    LIST_EXAMS_PREDICTOR_YEAR: "v1/admin/exams/list-year",

    ADD_FAQS: "v1/admin/exams-faqs/add-exam-faqs",
    LIST_FAQS: "v1/admin/exams-faqs/list-exam-faqs",
    UPDATE_FAQS: "v1/admin/exams-faqs/update-exam-faqs",
    DELECT_FAQS: "v1/admin/exams-faqs/delect-exam-faqs",

    ADD_QS_PAPER: "v1/admin/exams-questions/add-exam-questions",
    LIST_QS_PAPER: "v1/admin/exams-questions/list-exam-questions",
    UPDATE_QS_PAPER: "v1/admin/exams-questions/update-exam-questions",
    DELECT_QS_PAPER: "v1/admin/exams-questions/delect-exam-questions",

    ADD_ANSWERKEY_PAPER: "v1/admin/exams-questions/add-exam-answerkey",
    LIST_ANSWERKEY_PAPER: "v1/admin/exams-questions/list-exam-answerkey",
    UPDATE_ANSWERKEY_PAPER: "v1/admin/exams-questions/update-exam-answerkey",
    DELECT_ANSWERKEY_PAPER: "v1/admin/exams-questions/delect-exam-answerkey",

    ADD_MENU_SUBMENU: "v1/admin/exams-submenu/add-submenu",
    LIST_MENU_SUBMENU: "v1/admin/exams-submenu/list-submenu",
    UPDATE_MENU_SUBMENU: "v1/admin/exams-submenu/update-submenu",
    DELECT_MENU_SUBMENU: "v1/admin/exams-submenu/delect-submenu",
  },
};
